import { Box, Button, Typography } from '@mui/material';

export default function HomePersistenceNotice({
  phase,
  onRetry,
  onUseServer,
  onKeepLocal,
}) {
  if (!phase || phase === 'idle' || phase === 'recover') return null;
  const conflict = phase === 'conflict';
  const copy = {
    pending: 'Saving Home…',
    saving: 'Saving Home…',
    saved: 'Home saved',
    error: 'Home could not be saved.',
    conflict: 'This Home changed on another device. Your edits are still here.',
  }[phase];
  if (!copy) return null;
  return (
    <Box
      role="status"
      sx={{
        width: '100%',
        boxSizing: 'border-box',
        m: 0,
        px: 2,
        py: 1,
        borderRadius: 0,
        bgcolor: conflict || phase === 'error' ? 'warning.light' : 'action.hover',
        color: 'text.primary',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        alignItems: 'center',
        position: 'relative',
        zIndex: 1500,
        flexShrink: 0,
      }}
    >
      <Typography variant="body2" sx={{ flex: 1 }}>{copy}</Typography>
      {phase === 'error' ? <Button size="small" onClick={onRetry}>Retry</Button> : null}
      {conflict ? <Button size="small" onClick={onUseServer}>Use saved Home</Button> : null}
      {conflict ? <Button size="small" onClick={onKeepLocal}>Keep this browser’s Home</Button> : null}
    </Box>
  );
}
